<div class="row" role="main">
  <div class="col-md-12 col-sm-12 table-responsive no-border">
    <form [formGroup]="deviceForm" novalidate>
      <table class="table table-condensed">
        <tbody>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Primary DI" class="col-sm-4">Primary DI</th>
                    <th role="columnheader" aria-label="Issuing Agency" class="col-sm-8">Issuing Agency </th>
                  </tr>
                  <tr>
                    <td role="gridcell" aria-label="Cell of Primary DI">
                      <label controlName="udiDI"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Issuing Agency">
                      <label controlName="agency"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table formArrayName="tradeNamesForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Brand or Trade Name(s)">Brand or Trade Name(s)</th>
                  </tr>
                  <ng-container *ngIf="tradeNamesForm.controls.length; else emptyTemplate1field">
                  <tr formGroupName="{{i}}" *ngFor="let name of tradeNamesForm.controls; let i = index">
                    <td role="gridcell" aria-label="Cell for Brand or Trade Name(s)" colspan="2">
                      <label controlName="value"></label>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table formArrayName="deviceDescriptionForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Device Description">Device Description</th>
                  </tr>
                  <ng-container *ngIf="deviceDescriptionForm.controls.length; else emptyTemplate1field">
                  <tr formGroupName="{{i}}" *ngFor="let name of deviceDescriptionForm.controls; let i = index">
                    <td role="gridcell" aria-label="Cell for Device Description" colspan="2">
                      <label controlName="value"></label>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Quantity of Device" class="col-sm-6">Quantity of Device</th>
                    <th role="columnheader" aria-label="Unit of Use DI" class="col-sm-6">Unit of Use DI</th>
                  </tr>
                  <tr>
                    <td role="gridcell" aria-label="Cell of Quantity of Device">
                      <label controlName="quantityOfDevice"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Unit of Use DI">
                      <label controlName="unitOfUseDi"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
          </tr>
          <tr>
            <td colspan="2" class="no-left-padding no-right-padding">
              <table formArrayName="secondaryDiForm" class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Secondary DI" class="col-sm-6">Secondary DI</th>
                    <th role="columnheader" aria-label="Secondary DI Issuing Agency" class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <ng-container *ngIf="secondaryDiForm?.controls?.length; else emptyTemplate2fields">
                  <tr formGroupName="{{i}}" *ngFor="let item of secondaryDiForm.controls; let i = index">
                    <td role="gridcell" aria-label="Cell of Secondary DI">
                      <label controlName="diValue"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Secondary DI Issuing Agency">
                      <label controlName="diAgency"></label>
                    </td>
                  </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Direct Marking DI" class="col-sm-6">Direct Marking DI</th>
                    <th role="columnheader" aria-label="Direct Marking DI Issuing Agency" class="col-sm-6">Issuing Agency</th>
                  </tr>
                  <tr>
                    <td role="gridcell" aria-label="Cell of Direct Marking DI">
                      <label controlName="directMarkingDI"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Direct Marking DI Issuing Agency">
                      <label controlName="directMarkingDIAgency"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Catalog or Reference Number" class="col-sm-6">Catalog or Reference Number</th>
                  </tr>
                  <tr>
                    <td role="gridcell" aria-label="Cell of Catalog or Reference Number">
                      <label controlName="referenceOrCatalogNumber"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="2" class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="GMDN Code(s)" class="col-sm-3">GMDN Code(s)</th>
                    <th role="columnheader" aria-label="FDA Product Code(s)" class="col-sm-3" *ngIf="!isAustraliaChannel">FDA Product Code(s) </th>
                    <th role="columnheader" aria-label="Sponsor ID" class="col-sm-3" *ngIf="isAustraliaChannel">Sponsor ID</th>
                    <th role="columnheader" aria-label="Version or Model" class="col-sm-6">Version or Model </th>
                  </tr>
                  <tr>
                    <td>
                      <table formArrayName="GMDNform">
                        <tbody>
                          <ng-container *ngIf="GMDNform.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}" *ngFor="let code of GMDNform.controls; let i = index">
                              <td role="gridcell" aria-label="Cell of GMDN Code(s)">
                                <label controlName="code"></label>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                    <td formArrayName="fdaProductCodesForm" *ngIf="!isAustraliaChannel">
                      <table>
                        <tbody>
                          <ng-container *ngIf="fdaProductCodesForm.controls.length; else emptyTemplate1field">
                            <tr formGroupName="{{i}}" *ngFor="let code of fdaProductCodesForm.controls; let i = index">
                              <td role="gridcell" aria-label="Cell of FDA Product Code(s)">
                                <label controlName="fdaProductCode"></label>
                              </td>
                            </tr>
                          </ng-container>
                        </tbody>
                      </table>
                    </td>
                    <td role="gridcell" aria-label="Cell of Sponsor ID" *ngIf="isAustraliaChannel">
                      <label controlName="sponsorId"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Version or Model">
                      <label controlName="versionOrModel"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td colspan="1" class="no-left-padding no-right-padding">
              <table formArrayName="previousDiForm"
                class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Previous DI" class="col-sm-6">Previous DI</th>
                    <th role="columnheader" aria-label="Previous DI Issuing Agency" class="col-sm-6">Previous DI Issuing Agency</th>
                  </tr>
                  <ng-container *ngIf="previousDiForm.controls.length; else emptyTemplate2fields">
                    <tr formGroupName="{{i}}" *ngFor="let item of previousDiForm.controls; let i = index">
                      <td role="gridcell" aria-label="Cell of Previous DI">
                        <label controlName="diValue"></label>
                      </td>
                      <td role="gridcell" aria-label="Cell of Previous DI Issuing Agency">
                        <label controlName="diAgency"></label>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </td>
            <td colspan="1" class="no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped">
                <tbody>
                  <tr *ngIf="isAustraliaChannel">
                    <th role="columnheader" aria-label="Device Class" class="col-sm-5">Device Class</th>
                    <th role="columnheader" aria-label="Device Subject to Direct Marking (DM), but Expected?" class="col-sm-7">
                      Device Subject to Direct Marking (DM), but Excepted?
                    </th>
                  </tr>
                  <tr *ngIf="isAustraliaChannel">
                    <td role="gridcell" aria-label="Cell of Device Class">
                      <label controlName="deviceClass"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Device Subject to Direct Marking (DM), but Expected?">
                      <label controlName="directMarkingExempt"></label>
                    </td>
                  </tr>
                  <tr *ngIf="!isAustraliaChannel">
                    <th role="columnheader" aria-label="Labeler DUNS Number" class="col-sm-5">Labeler DUNS Number</th>
                    <th role="columnheader" aria-label="Device Subject to Direct Marking (DM), but Expected?" class="col-sm-7">
                      Device Subject to Direct Marking (DM), but Excepted?
                    </th>
                  </tr>
                  <tr *ngIf="!isAustraliaChannel">
                    <td role="gridcell" aria-label="Cell of Labeler DUNS Number">
                      <label controlName="labelerDuns"></label>
                    </td>
                    <td role="gridcell" aria-label="Cell of Device Subject to Direct Marking (DM), but Expected?">
                      <label controlName="directMarkingExempt"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td class="col-sm-6 no-left-padding no-right-padding">
              <table class="table table-inner table-condensed table-striped table-striped">
                <tbody>
                  <tr>
                    <th role="columnheader" aria-label="Production Identification Controlled By" class="col-sm-6">
                      Production Identification Controlled By:
                    </th>
                    <th role="gridcell" aria-label="Cell of Production Identification Controlled By" class="col-sm-6"></th>
                  </tr>
                  <tr>
                    <td role="columnheader" aria-label="Expiration Date?">Expiration Date?</td>
                    <td role="gridcell" aria-label="Cell of Expiration Date?">
                      <label controlName="isExpirationDate"></label>
                    </td>
                  </tr>
                  <tr>
                    <td role="columnheader" aria-label="Manufacturing Date?">Manufacturing Date?</td>
                    <td role="gridcell" aria-label="Cell of Manufacturing Date?">
                      <label controlName="isManufacturingDate"></label>
                    </td>
                  </tr>
                  <tr>
                    <td role="columnheader" aria-label="Lot or Batch Number?">Lot or Batch Number?</td>
                    <td role="gridcell" aria-label="Cell of Lot or Batch Number">
                      <label controlName="isLotOrBatchNumber"></label>
                    </td>
                  </tr>
                  <tr>
                    <td role="columnheader" aria-label="Serial Number?">Serial Number?</td>
                    <td role="gridcell" aria-label="Cell of Serial Number?">
                      <label controlName="isSerialNumber"></label>
                    </td>
                  </tr>
                  <tr>
                    <td role="columnheader" aria-label="Donation Identification Number?">Donation Identification Number?</td>
                    <td role="gridcell" aria-label="Cell of Donation Identification Number?">
                      <label controlName="controlledByDonationIdentificationNumber"></label>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
<ng-template #emptyTemplate1field>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
<ng-template #emptyTemplate2fields>
  <tr>
    <td><label class="label-padding-bottom-15"></label></td>
    <td><label class="label-padding-bottom-15"></label></td>
  </tr>
</ng-template>
